export type MeetingTypeVariant = 'standard' | 'private' | 'open';

export const MEETING_ACCESS_POLICY_TITLE = 'Meeting Access Policy';

export const MEETING_ACCESS_POLICY_OPTIONS: readonly {
  type: MeetingTypeVariant;
  label: string;
  description: string;
}[] = [
  {
    type: 'standard',
    label: 'Trusted Meetings',
    description:
      'Participants from your organization join immediately. Guests wait in the lobby until admitted by a host',
  },
  {
    type: 'private',
    label: 'Restricted Meetings',
    description:
      'All participants wait in the lobby and must be admitted by a host before joining the meeting',
  },
  {
    type: 'open',
    label: 'Public Meetings',
    description:
      'Anyone with the meeting link can join immediately once the host starts the meeting',
  },
];
